import { Refresh } from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { getDateAndTime } from '../../lib/utils';
import { Button as ReactButton } from 'react-bootstrap';

export const RefreshButton = ({
  onRefresh,          
  isFetching = false, 
  lastUpdated = null,  
  showLastUpdated = false,
  noOutline = false,
  buttonSize = 18,
  width = 26,
}) => {
  const handleClick = async () => {
    if (typeof onRefresh === 'function') {
      await onRefresh();
    }
  };

  const button = (
    <Button
      variant={noOutline ? 'text' : 'outlined'}
      className="remove-focus"
      onClick={handleClick}
      size="small"
      disableRipple
      disableFocusRipple
      color="primary"
      title="Click to refresh"
      sx={{
        minWidth: 'auto',
        padding: '2px 6px',
        height: width,
        width: width,
        ml: 1,
      }}
    >
      {isFetching ? (
        <CircularProgress size={18} />
      ) : (
        <Refresh sx={{ fontSize: buttonSize }} />
      )}
    </Button>
  );

  if (showLastUpdated && lastUpdated) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2" color="text.secondary">
          Last updated: {getDateAndTime(lastUpdated)}
        </Typography>
        {button}
      </Stack>
    );
  }

  return button;
};

export const TableRefreshButton = ({ refreshData }) => {
  return (
    <ReactButton
      variant="outline-secondary"
      className="remove-focus"
      onClick={refreshData}
      title="Click to refresh the list">
      <Refresh color={'#6c757d'} size={'20px'} />
    </ReactButton>
  );
};
